export default __webpack_public_path__ + "static/media/ClinicalNotesWhite@2x.80f45bb4.png";